import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function TrackingWarningModal({
  isOpen,
  onContinue,
  onSwitch,
  onClose,
}) {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
        <Modal.Header closeButton>
            <Modal.Title>Tracking & Reporting Notice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Please note that when selecting <strong>'Sampling'</strong> or <strong>'Creative Assets & UGC'</strong>, the platform will not track or report on any performance data.</p>
            <p>To measure and report on social performance, you must create a <strong>Social Media campaign</strong>.</p>
            <p>With <strong>'Creative Assets & UGC'</strong>, you will receive content assets; however, creators are not obligated to post on their own social media channels.</p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="outline-secondary" onClick={onSwitch}>Switch to Social Media Campaign</Button>
            <Button variant="primary" onClick={onContinue}>Continue</Button>
        </Modal.Footer>
    </Modal>
  );
}